import React from "react";
import I18n from "i18n-js";
import { ItemCards } from "presto-react-components";
import utils from "../../utils/index";
import _ from "lodash";
export default function ItemCardExpand(props) {
  let forwardProps = {
    ...props,
    offersCount: I18n.t("screen_messages.count_offers", {
      count: props?.product?.offersCount,
    }),
    is_sponsored: I18n.t("screen_messages.sponsored_text"),
  };
  if (!_.isFunction(props?.priceAccessorMethod)) {
    forwardProps.priceAccessorMethod = (product) => {
      return product.formatCurrency2;
    };
  }
  return <ItemCards.ItemCard10 {...forwardProps} />;
}
